// extracted by mini-css-extract-plugin
export default {"colorWhiteBackground":"G5bW5XAwRoPsQEtL3Y1FF","colorWhiteForeground":"_1OgkIywPKPjUxP2FtW7wQ-","colorMainForeground":"tbVgvL5Fo2Zsak6EvygGH"};